export default "__VITE_ASSET__DMRPism7__"